/**
 * SHOPIFY PREDICTIVE SEARCH WEB COMPONENT
 */

class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.setupEventListeners();
  }

  setupEventListeners() {
    if (!this.input) return;
    this.input.addEventListener('input', this.debounce((e) => {
      this.onChange(e);
    }, 300));
  }

  onChange() {
    const searchTerm = this.input.value.trim();
    if (!searchTerm.length) {
      this.close();
      return;
    }
    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest.json?q=${encodeURIComponent(searchTerm)}&resources[type]=product,collection,page&resources[limit]=5`)
      .then((response) => response.json())
      .then((suggestions) => {
        const products = suggestions.resources.results.products;
        if (!products || !products.length) {
          this.predictiveSearchResults.innerHTML = '<div style="padding:20px;text-align:center;color:var(--color-text-muted);">No results found</div>';
        } else {
          this.predictiveSearchResults.innerHTML = `
            <div style="padding:12px;font-weight:700;font-size:0.8rem;text-transform:uppercase;color:var(--color-text-muted);">Products</div>
            ${products.map(product => `
              <a href="${product.url}" style="display:flex;align-items:center;gap:12px;padding:8px 12px;border-radius:var(--radius-global);transition:background 0.2s;" onmouseover="this.style.background='var(--color-bg-secondary)'" onmouseout="this.style.background='transparent'">
                <img src="${product.image}" style="width:44px;height:44px;object-fit:cover;border-radius:6px;">
                <div>
                  <div style="font-weight:600;font-size:0.9rem;color:var(--color-text-primary);">${product.title}</div>
                  <div style="font-size:0.85rem;color:var(--color-accent);font-weight:700;">₹${product.price}</div>
                </div>
              </a>
            `).join('')}
          `;
        }
        this.open();
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
  }

  debounce(fn, wait) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);
